import { useCallback } from 'react';
import { useRegisterFeedbackMutation } from '../../../../__generated__/chirp/com/hubspot/academy/recommendations/rpc/ranked/RankedRecommendationService.hooks';
import Raven from 'raven-js';
export const usePostRankedRecommendationsFeedback = () => {
  const [mutate, {
    error: postRankedRecommendationsFeedbackError,
    loading: postRankedRecommendationsFeedbackLoading
  }] = useRegisterFeedbackMutation();
  const postRankedRecommendationsFeedback = useCallback(({
    entityType,
    entityId,
    content,
    correlationId
  }) => {
    const variables = {
      correlationId,
      options: content.map(r => ({
        // we have to send all items, even the non-clicked ones
        resultId: r.id,
        positive: r.id === entityId && r.type === entityType,
        contentContainerType: r.type
      }))
    };
    return mutate({
      variables,
      onError(error) {
        Raven.captureException(error);
      }
    });
  }, [mutate]);
  return {
    postRankedRecommendationsFeedback,
    postRankedRecommendationsFeedbackError,
    postRankedRecommendationsFeedbackLoading
  };
};